import FirebaseContext from './context';
import { withFirebase } from './wrapper';

import Firebase from './firebase';
export default Firebase;

export { FirebaseContext, withFirebase };
